"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainClasses = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const DST_1 = require("../../DST");
const action_1 = require("../../menu/action");
const function_1 = require("../../menu/function");
const MenuBox_1 = require("../../menu/MenuBox");
const account_1 = require("../account");
const app_1 = require("../app");
const classes_1 = require("../classes");
// @ts-ignore
const backhome_png_1 = __importDefault(require("../../../assest/icon/backhome.png"));
const DSLayoutComponent_1 = require("./DSLayoutComponent");
const HomeLayout_1 = require("./HomeLayout");
const meetmateTrust_1 = require("./meetmateTrust");
const MobileGNB_1 = __importDefault(require("./MobileLayout_Child/MobileGNB"));
const EventBandBanner_1 = require("./EventBandBanner");
exports.MainClasses = react_1.default.memo(() => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const classesTitle = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClassesTitle)(state));
    const user = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserAuthName)(state));
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const hiddenMenus = (0, react_redux_1.useSelector)((state) => (0, classes_1.getHiddenMenus)(state));
    const depths = (0, react_redux_1.useSelector)((state) => (0, function_1.getDepths)(state));
    const menu = (0, react_redux_1.useSelector)((state) => (0, function_1.getMenuData)(state), react_redux_1.shallowEqual);
    const [isScrolled, setIsScrolled] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (depths !== 'home') {
            setIsScrolled(false);
            return;
        }
        const root = document.getElementById('root');
        const handleScroll = () => setIsScrolled((root?.scrollTop ?? window.scrollY) > 0);
        root?.addEventListener('scroll', handleScroll);
        window.addEventListener('scroll', handleScroll);
        return () => {
            root?.removeEventListener('scroll', handleScroll);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [depths]);
    // meetmate(테스트 응시 팝업)에서 학생이 제출완료 후 '성적표 보기'를 누르면 opener(이 창)로
    // MIMAC_REQUEST_SCORE_PDF{test_id} 가 온다. mimac 이 기존 생성기로 성적표 PDF(바이트)를 만들어
    // 요청한 팝업(e.source)에 MIMAC_SCORE_PDF_DATA 로 회신 → meetmate 가 그 바이트를 팝업 안에서 렌더한다.
    // (성적표 PDF 생성기는 mimac 에만 존재. 리스너를 '항상 마운트되는' 이 레이아웃에 두어
    //  학생이 홈/목록/상세 어디서 테스트를 열었든 동작. 무거운 jspdf 는 요청 시에만 동적 import.)
    (0, react_1.useEffect)(() => {
        const onScorePdfRequest = (e) => {
            if (!e?.data || e.data.type !== 'MIMAC_REQUEST_SCORE_PDF' || !e.data.test_id)
                return;
            // 인바운드: 신뢰하는 meetmate 출처만 처리(임의 출처의 성적표 PDF 탈취 방지).
            // meetmateTrust 3중 레이어(우리가 연 팝업 신원 / 동일 상위 도메인 / 명시 목록·서픽스)로
            // 검증하므로 새 배포 환경에서도 도메인 하드코딩 없이 동작한다.
            if (!(0, meetmateTrust_1.isTrustedMeetmateMessage)(e))
                return;
            const source = e.source;
            const test_id = e.data.test_id;
            if (!source)
                return;
            const member_id = (0, account_1.getUserId)(APP.store.getState);
            // class_id 는 현재 URL(/class/{uuid})에서 추출 — GlobalStateProvider.classesId 와 동일 규칙.
            const class_id = (window.location.pathname.match(/\/class\/([0-9a-f-]+)/i) || [])[1] || '';
            if (!member_id || !class_id) {
                source.postMessage({ type: 'MIMAC_SCORE_PDF_ERROR', test_id, message: '성적표 정보를 확인할 수 없습니다.' }, e.origin);
                return;
            }
            import('../../DST/DSTL001/component/DSTL001_Detail_Child/scoreReportPdfFor')
                .then(({ generateScoreReportPdfFor }) => generateScoreReportPdfFor(test_id, member_id, class_id))
                .then(bytes => {
                source.postMessage({ type: 'MIMAC_SCORE_PDF_DATA', test_id, bytes }, e.origin);
            })
                .catch(err => {
                source.postMessage({ type: 'MIMAC_SCORE_PDF_ERROR', test_id, message: err?.message || '성적표를 불러오지 못했습니다.' }, e.origin);
            });
        };
        window.addEventListener('message', onScorePdfRequest);
        return () => window.removeEventListener('message', onScorePdfRequest);
    }, []);
    const handlerUpdateMenu = (menu, isMain = false) => {
        if (menu === 'logout') {
            (0, app_1.closeWindow)();
            return;
        }
        else if (menu === 'accept') {
            navigate('/accept');
            (0, app_1.closeWindow)();
            return;
        }
        else if (menu === 'error') {
            navigate('/error');
            (0, app_1.closeWindow)();
            return;
        }
        const menuItem = (0, function_1.getDefaultMenuByDepth)(menu, isTeacher, hiddenMenus);
        dispatch((0, action_1.updateMenu)(menu, {
            menu: menuItem,
            detail: 'list',
        }));
    };
    (0, react_1.useEffect)(() => {
        const throttleOut = (0, throttle_1.default)(() => {
            // @ts-ignore
            if (!user)
                location.href = '/error';
        }, 1000, { leading: false, trailing: true });
        throttleOut();
    }, [user]);
    const { name, menuList } = (0, react_1.useMemo)(() => {
        const normalizedHiddenMenus = (0, function_1.normalizeHiddenMenus)(hiddenMenus);
        const filterMenu = (menuList) => {
            const hideReplayByRole = normalizedHiddenMenus.includes('replay') ||
                (isTeacher
                    ? normalizedHiddenMenus.includes('replay-teacher')
                    : normalizedHiddenMenus.includes('replay-student'));
            return menuList.filter(menu => {
                if (menu === 'replay')
                    return !hideReplayByRole;
                return !normalizedHiddenMenus.includes(menu);
            });
        };
        switch (depths) {
            case 'home':
                return {
                    name: 'home',
                    menuList: filterMenu(['home']),
                };
            case 'learningManagement':
                return {
                    name: 'test',
                    menuList: filterMenu(['test', 'assignment', 'attendanceStatus']),
                };
            case 'myRoom':
                return {
                    name: 'test',
                    menuList: filterMenu(['test', 'assignment', 'gradeCard']),
                };
            case 'liveRoom':
                return {
                    name: 'reservation',
                    menuList: filterMenu([
                        'reservation',
                        'previous-conference',
                        'replay',
                        'content',
                    ]),
                };
            case 'learningSupportRoom':
                return {
                    name: 'learningSupportRoom',
                    menuList: isTeacher
                        ? filterMenu(['qna', 'resource', 'survey', 'sendSMS'])
                        : filterMenu(['qna', 'resource', 'survey']),
                };
            case 'notice':
                return {
                    name: 'notice',
                    menuList: filterMenu(['notice']),
                };
            default:
                return {
                    name: 'home',
                    menuList: filterMenu(['home']),
                };
        }
    }, [depths, hiddenMenus, isTeacher]);
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [isHovered, setIsHovered] = react_1.default.useState(false);
    // const isWhite = useMemo(() => depths === 'home' || !isTeacher && depths === 'liveRoom', [menu, isTeacher, depths]);
    const isWhite = (0, react_1.useMemo)(() => depths === 'home', [depths]);
    const hideMenu = (0, react_1.useMemo)(() => depths === 'notice' || (!isTeacher && depths === 'liveRoom'), [isTeacher, depths]);
    const mobileName = (0, react_redux_1.useSelector)((state) => (0, function_1.getMobileName)(state));
    const marqueeRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (marqueeRef.current) {
            const textWidth = marqueeRef.current.offsetWidth; // 텍스트 너비
            const containerWidth = marqueeRef.current.parentElement.offsetWidth; // 컨테이너 너비
            if (textWidth > containerWidth) {
                // 텍스트가 컨테이너를 초과한 경우 애니메이션 적용
                const totalDistance = textWidth + containerWidth; // 이동 거리
                const duration = (totalDistance / 100) * 2; // 속도 계산 (조정 가능)
                marqueeRef.current.style.animation = `slide-left ${duration}s linear infinite`;
            }
            else {
                // 텍스트가 overflow되지 않으면 애니메이션 제거
                marqueeRef.current.style.animation = 'none';
            }
        }
    }, [mobileName]);
    // iPadOS on Safari can report itself as Mac; use maxTouchPoints to detect iPad safely.
    const isIpad = /iPad/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    (0, react_1.useEffect)(() => {
        if (!isIpad)
            return;
        // Keep touch scrolling enabled while applying iPad-specific touch-action handling.
        const prevHtmlTouchAction = document.documentElement.style.touchAction;
        const prevBodyTouchAction = document.body.style.touchAction;
        const root = document.getElementById('root');
        const prevRootTouchAction = root?.style.touchAction;
        document.documentElement.style.touchAction = 'pan-x pan-y';
        document.body.style.touchAction = 'pan-x pan-y';
        if (root)
            root.style.touchAction = 'pan-x pan-y';
        return () => {
            document.documentElement.style.touchAction = prevHtmlTouchAction;
            document.body.style.touchAction = prevBodyTouchAction;
            if (root)
                root.style.touchAction = prevRootTouchAction || '';
        };
    }, [isIpad]);
    if (!user || !menu)
        return null;
    return (react_1.default.createElement("div", { className: `ds-layout
			${isWhite ? 'box-white' : ''}
			${isTablet ? 'tablet' : isMobile ? 'mobile' : 'desktop'}` },
        depths === 'home' && react_1.default.createElement("img", { className: "back_home", src: backhome_png_1.default }),
        react_1.default.createElement(DSLayoutComponent_1.DSLayoutHeader, { isTeacher: isTeacher, title: isDesktop && classesTitle, isHome: depths === 'home', isScrolled: isScrolled, isHovered: isHovered, selectedMenu: menu?.menu?.menu, setIsHovered: setIsHovered, setMenu: handlerUpdateMenu }, isDesktop ? (react_1.default.createElement(DST_1.NavbarContainer, { isTeacher: isTeacher, menu: depths, setIsHovered: setIsHovered, isHovered: isHovered, setMenu: menu => handlerUpdateMenu(menu, true) })) : (react_1.default.createElement("div", { className: "mobile_nav" },
            react_1.default.createElement(common_1.Button, { option: {
                    buttonBeforeIcon: {
                        show: depths !== 'home',
                        name: 'arrow',
                        size: 32,
                        color: isWhite ? Colors_1.Colors.white : Colors_1.Colors.black,
                    },
                }, onClick: depths !== 'home'
                    ? () => {
                        dispatch((0, action_1.goToPrevMenu)());
                    }
                    : undefined }),
            react_1.default.createElement("div", { className: `title-name-gnb ${isDesktop ? 'overText' : ''} ${typeof mobileName === 'string' ? 'string' : ''}` },
                react_1.default.createElement("div", { ref: marqueeRef }, depths !== 'home' ? mobileName : '')),
            react_1.default.createElement(MobileGNB_1.default, { isWhite: isWhite && !isScrolled, isTeacher: isTeacher, selectedMenu: menu?.menu.menu })))),
        depths === 'home' ? (react_1.default.createElement(HomeLayout_1.HomeLayout, { isTeacher: isTeacher })) : (react_1.default.createElement(DSLayoutComponent_1.DSBody, { title: isTablet ||
                (isMobile && menu.menu.detail !== 'detail') ||
                ((menu.menu.menu === 'assignment' || menu.menu.menu === 'reservation') &&
                    menu.menu.detail === 'regist')
                ? classesTitle
                : undefined, isWhite: isWhite, name: name, menuList: menuList, hideBody: true },
            react_1.default.createElement(MenuBox_1.MenuBox, { isTeacher: isTeacher, name: name, menuList: menuList, hideMenu: hideMenu }))),
        (isMobile || isTablet) && (react_1.default.createElement("div", { className: "bottom-nav" },
            react_1.default.createElement(DST_1.NavbarContainer, { isFooter: true, isTeacher: isTeacher, menu: depths, setMenu: menu => {
                    if (menu === 'logout') {
                        (0, app_1.closeWindow)();
                        return;
                    }
                    handlerUpdateMenu(menu, true);
                } }))),
        react_1.default.createElement(EventBandBanner_1.EventBandBanner, null)));
});
